import { QueryErrorBoundary } from '@/catalog-apps/components/QueryErrorBoundary'
import { AppDatabricksPageContent } from './AppDatabricksPageContent'
import { Suspense } from 'react'
import { ApplicationsBreadcrumb } from '../ApplicationsBreadcrumbs'
import { LoadingComponent } from '@/components/ui/LoadingComponent'
import { IconWaitOutline } from '@icons/IconWaitOutline'
import { MAIN_CONTENT_HEIGHT_LESS_PAGE_HEADER } from '@/catalog-apps/components/config'

export const AppDatabricksPage = () => {
  return (
    <>
      <ApplicationsBreadcrumb title="Databricks" />
      <QueryErrorBoundary errorMessage="Failed to fetch Databricks status">
        <Suspense
          fallback={
            <LoadingComponent
              style={{ height: MAIN_CONTENT_HEIGHT_LESS_PAGE_HEADER }}
              icon={<IconWaitOutline size={72} fontSize={96} />}
              text="Loading Databricks status. This may take a few minutes..."
            />
          }
        >
          <AppDatabricksPageContent />
        </Suspense>
      </QueryErrorBoundary>
    </>
  )
}
